module.exports = __webpack_public_path__ + "static/assets/5f938bab889846bc943e0042be04bca8.svg";